import React, { useState, useEffect, useContext } from 'react';
import { Container, Button, Dropdown, Badge, Image } from 'react-bootstrap';
import { useAuth } from '../../contexts/AuthContext/AuthContext';
import { useNavigate, Link } from 'react-router-dom';
import TestModeToggle from '../TestMode/TestModeToggle';
import PortalShellContext from './PortalShellContext';
import logoShort from '../../assets/LOGOshort.png';

const PortalHeader = ({ title, subtitle }) => {
	const { currentUser, logout, userRole } = useAuth();
	const navigate = useNavigate();
	const inShell = useContext(PortalShellContext);
	const [isStandalone, setIsStandalone] = useState(false);

	useEffect(() => {
		// Check if running as installed PWA
		const standalone = window.matchMedia('(display-mode: standalone)').matches ||
		                   window.navigator.standalone === true;
		setIsStandalone(standalone);
	}, []);

	// Inside the persistent portal shell, the global chrome (logo, user menu,
	// test toggle, App Mode badge) lives in the shell top bar. Render only a
	// slim page-title heading here so we don't duplicate that chrome.
	if (inShell) {
		return (
			<div className='portal-page-heading'>
				<h1>{title}</h1>
				{subtitle && <p className='text-muted'>{subtitle}</p>}
			</div>
		);
	}

	const handleLogout = async () => {
		try {
			await logout();
			navigate('/portal/login');
		} catch (error) {
			console.error('Logout error:', error);
		}
	};

	return (
		<div className='border-bottom mb-4 pb-3'>
			<Container className='d-flex justify-content-between align-items-center'>
				<div className='d-flex align-items-center gap-3'>
					<Link to='/' onClick={() => window.scrollTo(0, 0)}>
						<Image
							src={logoShort}
							alt='Color Your Voice Logo'
							style={{ height: '40px', width: 'auto' }}
						/>
					</Link>
					<div>
						<div className='d-flex align-items-center gap-2 mb-1'>
							<h1 className='mb-0' style={{ color: '#384971' }}>
								{title}
							</h1>
							{isStandalone && (
								<Badge
									bg="success"
									className="d-flex align-items-center gap-1"
									style={{
										fontSize: '0.65rem',
										padding: '0.25rem 0.5rem',
										fontWeight: 'normal'
									}}
								>
									<i className="fa-sharp fa-solid fa-mobile-screen"></i>
									App Mode
								</Badge>
							)}
						</div>
						{subtitle && <p className='text-muted mb-0'>{subtitle}</p>}
					</div>
				</div>
				<div className='d-flex align-items-center gap-3'>
					{/* Test Mode Toggle - Only for Employee/Admin */}
					{(userRole === 'employee' || userRole === 'admin') && (
						<TestModeToggle />
					)}

					<div className='text-end d-none d-md-block'>
						<small className='text-muted d-block'>
							{currentUser?.email}
						</small>
						<small className='badge bg-primary'>
							{userRole === 'admin' ? 'Admin' : userRole === 'employee' ? 'Employee' : 'Customer'}
						</small>
					</div>
					<Dropdown align='end'>
						<Dropdown.Toggle variant='outline-secondary' id='user-dropdown'>
							<i className='fa-sharp fa-solid fa-user'></i>
						</Dropdown.Toggle>

						<Dropdown.Menu>
							<Dropdown.Header>
								<small>{currentUser?.email}</small>
							</Dropdown.Header>
							<Dropdown.Divider />
							<Dropdown.Item onClick={handleLogout}>
								<i className='fa-sharp fa-solid fa-right-from-bracket me-2'></i>
								Log Out
							</Dropdown.Item>
						</Dropdown.Menu>
					</Dropdown>
				</div>
			</Container>
		</div>
	);
};

export default PortalHeader;
